import {
    OTHER_DETAILS,
    VENDOR_INFORMATION,
    VENDOR_ADDRESS,
    STATION_TYPE,
    STATION_DETAILS,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/ESLApplication';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatESLApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let baseLandFixedStationInfo = [];
    let mobilePortableStationInfo = [];
    let mobilesCommunicateWith: any = [];
    let coverageInformation: any = [];

    newDocs = [];

    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    for (const key in licenceDetails.supportingDocuments) {
        if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.mobileStationApplication && licenceDetails.mobileStationApplication.length > 0) {
        mobilesCommunicateWith = licenceDetails?.mobileStationApplication[0]?.mobileSCommunicateWith?.map((i: any) => i.mixedValue);
    }

    if (licenceDetails && licenceDetails.mobileStationApplication && licenceDetails.mobileStationApplication.length > 0) {
        coverageInformation = licenceDetails?.mobileStationApplication[0]?.coverageInformationPageLst?.map((i: any) => i.mixedValue);
    }

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        baseLandFixedStationInfo = licenceDetails?.baseLandFixedStationInfo
            ?.map((value: any) => ({
                'call-sign': value?.callSign ?? '-',
                'station-name': value?.stationName ?? '-',
                'location-of-station': value?.locationOfStationEGRooftop ?? '-',
                'building-name': value?.address?.buildingName ?? '-',
                'postal-code': value?.address?.postalCode ?? '-',
                'street-name': value?.address?.streetName ?? '-',
                'block-house-no': value?.address?.blockNo ?? '-',
                'floor-level': value?.address?.floor ?? '-',
                unit: value?.address?.unit ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'building-height-m': value?.buildingHeightM ?? '-',
                'antenna-effective-height-m-above-ground-level': value?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
                'elevation-above-mean-sea-level': value?.elevationAboveMeanSeaLevelM ?? '-',
                transportable: value?.transportable ?? '-',
                'manufacturer-transmitter': value?.manufacturerTransmitter ?? '-',
                'manufacturer-receiver': value?.manufacturerReceiver ?? '-',
                'model-transmitter': value?.modelTransmitter ?? '-',
                'model-receiver': value?.modelReceiver ?? '-',
                'output-power-w-transmitter': value?.outputPowerWTransmitter ?? '-',
                'antenna-manufacturer': value?.antennaManufacturer ?? '-',
                polarization: value?.polarization ?? '-',
                'antenna-displacement-from-station': value?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
                'north-latitude-displacement': value?.northLatitudeDisplacementM ?? '-',
                'east-longitude-displacement': value?.eastLongitudeDisplacementM ?? '-',
                'gain-db': value?.gainDB ?? '-',
                'filter-manufacturer': value?.filterManufacturer ?? '-',
                model: value?.model ?? '-',
                'insertion-loss-db': value?.insertionLossDB ?? '-',
                'tuned-frequency-mhz': value?.tunedFrequencyMHz ?? '-',
                'feeder-information': value?.feederInformation ?? '-',
                'feeder-line-type-transmit': value?.feederLineTypeTransmit ?? '-',
                'feeder-line-type-receive': value?.feederLineTypeReceive ?? '-',
                'feeder-line-length-m-transmit': value?.feederLineLengthMTransmit ?? '-',
                'feeder-line-length-m-receive': value?.feederLineLengthMReceive ?? '-',
                'feeder-line-loss-db-transmit': value?.feederLineLossDBTransmit ?? '-',
                'feeder-line-loss-db-receive': value?.feederLineLossDBReceive ?? '-',
                'frequency-and-emission-class-information':
                    value?.frequencyInformationBaseLandFixedStation.map((i: any) => {
                        return {
                            'desired-frequency-mhz-from-tx': i.desiredFrequencyMHzFromTransmit ?? '-',
                            'desired-frequency-mhz-to-tx': i.desiredFrequencyMHzToTransmit ?? '-',
                            'desired-frequency-mhz-from-rx': i.desiredFrequencyMHzFromReceive ?? '-',
                            'desired-frequency-mhz-to-rx': i.desiredFrequencyMHzToReceive ?? '-',
                            'desired-bandwidth-khz-tx': i.bandwidthKHzTransmit ?? '-',
                            'desired-bandwidth-khz-rx': i.bandwidthKHzReceive ?? '-',

                            'assigned-frequency-mhz-from-tx': i.assignedFrequencyMHzFromTransmit ?? '-',
                            'assigned-frequency-mhz-to-tx': i.assignedFrequencyMHzToTransmit ?? '-',
                            'assigned-frequency-mhz-from-rx': i.assignedFrequencyMHzFromReceive ?? '-',
                            'assigned-frequency-mhz-to-rx': i.assignedFrequencyMHzToReceive ?? '-',
                            'assigned-bandwidth-khz-tx': i.AssignedBandwidthTx ?? '-',
                            'assigned-bandwidth-khz-rx': i.AssignedBandwidthRx ?? '-',

                            'start-time': i.startTime ?? '-',
                            'stop-time': i.stopTime ?? '-',

                            'emission-class-transmit': i?.emissionClassTransmit ?? '-',
                            'emission-class-receive': i?.emissionClassReceive ?? '-'
                        };
                    }) ?? '-'
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`call-sign-${index}`]: item['call-sign'],
                    [`station-name-${index}`]: item['station-name'],
                    [`location-of-station-${index}`]: item['location-of-station'],
                    [`building-name-${index}`]: item['building-name'],
                    [`postal-code-${index}`]: item['postal-code'],
                    [`street-name-${index}`]: item['street-name'],
                    [`block-house-no-${index}`]: item['block-house-no'],
                    [`floor-level-${index}`]: item['floor-level'],
                    [`unit-${index}`]: item['unit'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`building-height-m-${index}`]: item['building-height-m'],
                    [`antenna-effective-height-m-above-ground-level-${index}`]: item['antenna-effective-height-m-above-ground-level'],
                    [`elevation-angle-${index}`]: item['elevation-angle'],
                    [`transportable-${index}`]: item['transportable'],
                    [`manufacturer-transmitter-${index}`]: item['manufacturer-transmitter'],
                    [`manufacturer-receiver-${index}`]: item['manufacturer-receiver'],
                    [`model-transmitter-${index}`]: item['model-transmitter'],
                    [`model-receiver-${index}`]: item['model-receiver'],
                    [`output-power-w-transmitter-${index}`]: item['output-power-w-transmitter'],
                    [`antenna-manufacturer-${index}`]: item['antenna-manufacturer'],
                    [`polarization-${index}`]: item['polarization'],
                    [`antenna-displacement-from-station-${index}`]: item['antenna-displacement-from-station'],
                    [`north-latitude-displacement-${index}`]: item['north-latitude-displacement'],
                    [`east-longitude-displacement-${index}`]: item['east-longitude-displacement'],
                    [`gain-db-${index}`]: item['gain-db'],
                    [`filter-manufacturer-${index}`]: item['filter-manufacturer'],
                    [`model-${index}`]: item['model'],
                    [`insertion-loss-db-${index}`]: item['insertion-loss-db'],
                    [`tuned-frequency-mhz-${index}`]: item['tuned-frequency-mhz'],
                    [`feeder-information-${index}`]: item['feeder-information'],
                    [`feeder-line-type-transmit-${index}`]: item['feeder-line-type-transmit'],
                    [`feeder-line-type-receive-${index}`]: item['feeder-line-type-receive'],
                    [`feeder-line-length-m-transmit-${index}`]: item['feeder-line-length-m-transmit'],
                    [`feeder-line-loss-db-transmit-${index}`]: item['feeder-line-loss-db-transmit'],
                    [`feeder-line-loss-db-receive-${index}`]: item['feeder-line-loss-db-receive'],
                    [`frequency-and-emission-class-information-${index}`]: item['frequency-and-emission-class-information']
                };
            });
    }

    if (licenceDetails && licenceDetails.mobileStationApplication && licenceDetails.mobileStationApplication.length > 0) {
        mobilePortableStationInfo = licenceDetails?.mobileStationApplication
            ?.map((value: any) => ({
                'no-of-mobiles': value?.noOfMobiles ?? '-',
                'mobiles-communicate-with': mobilesCommunicateWith ?? '-',
                'coverage-information': coverageInformation ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'mobile-station-frequency-info':
                    value?.frequencyInformationMobileStation.map((i: any, index: any) => {
                        return {
                            'id-no': index + 1,
                            manufacturer: i.manufacturer ?? '-',
                            model: i.model ?? '-',

                            'desired-frequency-mhz-from-tx': i.desiredFrequencyMHzFromTransmit ?? '-',
                            'desired-frequency-mhz-to-tx': i.desiredFrequencyMHzToTransmit ?? '-',
                            'desired-frequency-mhz-from-rx': i.desiredFrequencyMHzFromReceive ?? '-',
                            'desired-frequency-mhz-to-rx': i.desiredFrequencyMHzToReceive ?? '-',
                            'desired-bandwidth-khz-tx': i.bandwidthKHzTransmit ?? '-',
                            'desired-bandwidth-khz-rx': i.bandwidthKHzReceive ?? '-',

                            'assigned-frequency-mhz-from-tx': i.assignedFrequencyMHzFromTransmit ?? '-',
                            'assigned-frequency-mhz-to-tx': i.assignedFrequencyMHzToTransmit ?? '-',
                            'assigned-frequency-mhz-from-rx': i.assignedFrequencyMHzFromReceive ?? '-',
                            'assigned-frequency-mhz-to-rx': i.assignedFrequencyMHzToReceive ?? '-',
                            'bandwidth-khz-tx': i.bandwidthKHzTransmit ?? '-',
                            'bandwidth-khz-rx': i.bandwidthKHzReceive ?? '-',

                            'emission-class-tx': i.emissionClassTransmit ?? '-',
                            'emission-class-rx': i.emissionClassReceive ?? '-'
                        };
                    }) ?? '-'
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`no-of-mobiles-${index}`]: item['no-of-mobiles'],
                    [`mobiles-communicate-with-${index}`]: item['mobiles-communicate-with'],
                    [`coverage-information-${index}`]: item['coverage-information'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`mobile-station-frequency-info-${index}`]: item['mobile-station-frequency-info']
                };
            });
    }

    licence = {
        id: 'experimental-station-licence',
        formID: 'experimental-station-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.purposeOfApplicationPage?.proposedUseOfSystemEquipment ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.purposeOfApplicationPage?.remarks ?? '-',
            [`${OTHER_DETAILS}-do-you-have-any-equipment-vendor`]:
                licenceDetails?.purposeOfApplicationPage?.doYouHaveAnyEquipmentVendor ?? '-',

            [`${VENDOR_INFORMATION}-company-name`]: licenceDetails?.vendorInformation?.CompanyName ?? '-',
            [`${VENDOR_INFORMATION}-vendor-dealers-licence-number`]: licenceDetails?.vendorInformation?.vendorSDealerSLicenceNumber ?? '-',
            [`${VENDOR_INFORMATION}-contact-person`]: licenceDetails?.vendorInformation?.contactPersonName ?? '-',
            [`${VENDOR_INFORMATION}-contact-number`]: licenceDetails?.vendorInformation?.ContactNumber ?? '-',

            [`${VENDOR_ADDRESS}-building-name`]: licenceDetails?.vendorInformation?.address?.buildingName ?? '-',
            [`${VENDOR_ADDRESS}-postal-code`]: licenceDetails?.vendorInformation?.address?.postalCode ?? '-',
            [`${VENDOR_ADDRESS}-street-name`]: licenceDetails?.vendorInformation?.address?.streetName ?? '-',
            [`${VENDOR_ADDRESS}-block-house-no`]: licenceDetails?.vendorInformation?.address?.blockNo ?? '-',
            [`${VENDOR_ADDRESS}-floor-level`]: licenceDetails?.vendorInformation?.address?.floor ?? '-',
            [`${VENDOR_ADDRESS}-unit`]: licenceDetails?.vendorInformation?.address?.unit ?? '-',

            [`${STATION_TYPE}-station-type`]: licenceDetails?.baseLandFixedStationWithMobileStation?.stationType ?? '-',

            [`${STATION_DETAILS}-station-tabs`]: [
                { 'fixed-station-licence': [...baseLandFixedStationInfo] },
                { 'mobile-station-licence': [...mobilePortableStationInfo] }
            ],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '-',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '-',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '-',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '-',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '-',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '-',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '-',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '-',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '-',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '-',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '-',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '-',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '-',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? '-'
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-experimental-station-licence',
            formID: 'amend-experimental-station-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
            values: {
                [`${OTHER_DETAILS}-amend-table`]: Array.isArray(mapped) && mapped.length > 0 ? [...mapped] : [],
                [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.purposeOfApplicationPage?.proposedUseOfSystemEquipment ?? '-',
                [`${OTHER_DETAILS}-remarks`]: licenceDetails?.purposeOfApplicationPage?.remarks ?? '-',
                [`${OTHER_DETAILS}-do-you-have-any-equipment-vendor`]:
                    licenceDetails?.purposeOfApplicationPage?.doYouHaveAnyEquipmentVendor ?? '-',

                [`${VENDOR_INFORMATION}-company-name`]: licenceDetails?.vendorInformation?.CompanyName ?? '-',
                [`${VENDOR_INFORMATION}-vendor-dealers-licence-number`]:
                    licenceDetails?.vendorInformation?.vendorSDealerSLicenceNumber ?? '-',
                [`${VENDOR_INFORMATION}-contact-person`]: licenceDetails?.vendorInformation?.contactPersonName ?? '-',
                [`${VENDOR_INFORMATION}-contact-number`]: licenceDetails?.vendorInformation?.ContactNumber ?? '-',

                [`${VENDOR_ADDRESS}-building-name`]: licenceDetails?.vendorInformation?.address?.buildingName ?? '-',
                [`${VENDOR_ADDRESS}-postal-code`]: licenceDetails?.vendorInformation?.address?.postalCode ?? '-',
                [`${VENDOR_ADDRESS}-street-name`]: licenceDetails?.vendorInformation?.address?.streetName ?? '-',
                [`${VENDOR_ADDRESS}-block-house-no`]: licenceDetails?.vendorInformation?.address?.blockNo ?? '-',
                [`${VENDOR_ADDRESS}-floor-level`]: licenceDetails?.vendorInformation?.address?.floor ?? '-',
                [`${VENDOR_ADDRESS}-unit`]: licenceDetails?.vendorInformation?.address?.unit ?? '-',

                [`${STATION_TYPE}-station-type`]: licenceDetails?.baseLandFixedStationWithMobileStation?.stationType ?? '-',

                [`${STATION_DETAILS}-station-tabs`]: [
                    { 'fixed-station-licence': [...baseLandFixedStationInfo] },
                    { 'mobile-station-licence': [...mobilePortableStationInfo] }
                ],

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    return licence;
};

const eslApplicationPayload = {
    formatESLApplication
};

export default eslApplicationPayload;
